import { State } from 'src/replicant/State';
import { duration } from 'src/replicant/utils/duration';
import { getMatch2Level } from '../match2.getters';

/**
 * Check whether the user has a current, unexpired Match2 save state.
 *
 * @param state Player state containing Match2 progress and save-state data.
 * @param now Current timestamp used to validate save-state age.
 * @returns Whether the saved gameplay state can be resumed.
 */
export function hasValidSaveState(state: State, now: number): boolean {
  // Return false if there is no save state
  if (!state.match2.saveState) {
    return false;
  }

  // Return false if the save state is not for the current playable level.
  const currentLevel = getMatch2Level(state, true);
  if (state.match2.saveState.level !== currentLevel) {
    return false;
  }

  // Return false if the save state is older than 2 hours
  if (now - state.match2.saveState.timestamp > duration({ hours: 2 })) {
    return false;
  }

  // Save state exists and still valid
  return true;
}
